module.exports = __webpack_public_path__ + "media/images/icon/dashboard-black-71fbfb3ee70e2c4f8bb523fdfee80a00.svg";